import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface ConfirmationData {
  code: string;
  email: string;
  hashId: string;
}

const useVerifyEmailForContactQuery = () => {
  const { mutateAsync, isLoading, isError, isSuccess } = useMutation(
    ({ code, email, hashId }: ConfirmationData) =>
      api.patch(API_URL.CONTACTS_EMAIL_VERIFICATIONS, {
        code: code,
        email: email,
        hash_id: hashId,
      })
  );

  return {
    verifyEmail: mutateAsync,
    isLoading,
    isError,
    isSuccess,
  };
};

export default useVerifyEmailForContactQuery;
